import { Component, OnInit } from '@angular/core';
import { VITALS_FIELD } from 'src/app/global';
import { PatientDashboardTabComponent } from 'src/app/patients/dashboard-page/dashboard-tab/dashboard-tab.component';
import { Vital } from 'src/app/calvin-emr-shared/models/vitals.model';
import { PatientDashboardStore } from 'src/app/patients/state/dashboard-page.store';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { Store } from '@ngrx/store';
import { VitalsFormComponent } from './vitals-form/vitals-form.component';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { NgStyle } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { VitalsChartComponent } from './vitals-chart/vitals-chart.component';

@Component({
    selector: 'app-vitals-tab',
    templateUrl: './vitals-tab.component.html',
    styleUrls: ['./vitals-tab.component.scss'],
    standalone: true,
    imports: [
        VitalsFormComponent,
        TableModule,
        PrimeTemplate,
        NgStyle,
        ButtonDirective,
        TooltipModule,
        VitalsChartComponent,
    ],
})
export class VitalsTabComponent extends PatientDashboardTabComponent implements OnInit {
  /**
   * Vitals that can be viewed in the Vitals chart.
   */
  viewableVitals: string[] = [
    'Heart Rate',
    'Oxygen Saturation',
    'Respirations',
    'Temperature',
    'Systolic BP',
    'Diastolic BP',
  ];

  vitals: Vital[] = [];

  constructor(patientStore: PatientDashboardStore, store: Store) {
    super(patientStore, store);
    this.patient$.subscribe((patient: Patient) => {
      this.vitals = patient.vitals;
    });
  }

  ngOnInit(): void {}

  /**
   *
   * @param vital The Vital object to add to the patient's vitals array.
   */
  addVital(vital: Vital) {
    this.vitals.push(vital);
    this.updatePatientField(VITALS_FIELD, this.vitals);
  }

  editVital(vital: Vital) {
    console.log('Edit');
    this.updatePatientField(VITALS_FIELD, this.vitals);
  }

  /**
   * Deletes a Vital from the local vitals array if the user has the admin role.
   * If the user is not an admin, the function toggles the 'deleted' property of
   * the Vital object.
   *
   * @param vital The Vital to delete.
   */
  deleteVital(vital: Vital): void {
    if (this.isAdmin) {
      this.vitals = this.vitals.filter((v) => v != vital);
    } else {
      vital.toggleDelete();
    }
    this.updatePatientField(VITALS_FIELD, this.vitals);
  }
}
